import Axios from "axios";

const api = Axios;

export default api;

export const get = (url, options) =>
  api.get(url, options).then(({ data }) => data);
